import React from 'react'
import { Helmet } from 'react-helmet'
import CustomerRegisterContainer from 'containers/panel/customer/register-container'
const CustomerRegisterPage = () => {
  return (
    <>
     <Helmet>
      <title>Kayıt | SkyPay</title>
    </Helmet>
    <CustomerRegisterContainer/>
    </>
  )
}

export default CustomerRegisterPage